import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=0560d4fe&scoped=true&"
import script from "./CollectionPage.vue?vue&type=script&lang=js&"
export * from "./CollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560d4fe",
  null
  
)

export default component.exports